<template>
  <div>
    <div class="card">
      <div class="card-header card-header-flex" style="width: 100%; overflow-x: auto; overflow-y: hidden;">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0 mr-4" style="min-width: max-content;">Permisos</h5>
        </div>
      </div>
      <div class="card-body">
        <template>
          <b-row>
            <a-tooltip placement="top">
              <template slot="title">
                <span>Crear permiso</span>
              </template>
              <button @click="openModal(false)" type="button" class="btn btn-primary btnplus mr-2 pb-1">
                <i class="fa fa-plus pt-1" />
              </button>
            </a-tooltip>
            <div class="col">
              <h5 class="mb-4">
                <strong>Lista de permisos</strong>
                <a-button class="ml-2" type="primary" v-b-toggle.collapse-1  shape="circle" icon="search"/>
              </h5>
            </div>
          </b-row>
          <b-collapse id="collapse-1" class="mt-2">
            <b-form>
              <b-row>
                <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                  <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
                    <b-form-input id="input-2" v-model="searchBar.name" placeholder="Ingrese el nombre"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-10 col-md-4 col-lg-3 col-xl-2">
                  <b-form-group id="input-group-3" label="Módulo:" label-for="input-3">
                    <b-form-select
                      id="input-3"
                      v-model="searchBar.idModule"
                      :options="modules"
                      required
                    ></b-form-select>
                  </b-form-group>
                </div>
              </b-row>
            </b-form>
          </b-collapse>
          <b-row>
            <div class="col">
              <b-table id="my-table" v-if="permissions.length !== 0" striped hover :fields="columns" :items="permissions" :per-page="pagination.perPage" :current-page="pagination.currentPage" head-variant="light" responsive>
                <template #cell(idModule)="permission">
                  {{ moduleName(permission.item.idModule) }}
                </template>
                <template #cell(actions)="permission">
                  <div>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>Ver Roles/Usuarios vinculados</span>
                      </template>
                      <button type="button" @click="() => linkToPermission(permission.item, 0)" class="btn btn-light mr-2">
                        <i class="fa fa-eye" />
                      </button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>Editar</span>
                      </template>
                      <button @click="openModal(permission.item)" type="button" class="btn btn-light mr-2">
                        <i class="fa fa-pencil text-blue" />
                      </button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>Asignar Roles/Usuario</span>
                      </template>
                      <button type="button" @click="() => linkToPermission(permission.item, 1)" class="btn btn-light mr-2">
                        <i class="fa fa-plus-circle" />
                      </button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>Eliminar permiso</span>
                      </template>
                      <button type="button" v-on:click="deletePermission(permission.item)" class="btn btn-light mr-2">
                        <i class="fa fa-times-circle text-red" />
                      </button>
                    </a-tooltip>
                  </div>
                </template>
              </b-table>
              <empty-table v-else/>
            </div>
          </b-row>
          <b-row>
            <b-col>
              <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.rows"
                :per-page="pagination.perPage"
                aria-controls="my-table"
              ></b-pagination>
            </b-col>
            <b-col class="text-right">
              {{ pagination.rows }} resultados
            </b-col>
          </b-row>
        </template>
      </div>
    </div>
    <b-modal id="permission-modal" ref="modal" size="md" title="Información del permiso" hide-footer>
      <b-row class="mb-3">
        <b-col xl="9">
          Roles con este permiso:
        </b-col>
      </b-row>
      <template v-if="permissionSelected.actualRoles.length > 0">
        <b-row :id="index" v-for="(item,index) in permissionSelected.actualRoles" v-bind:key="item.id">
          <b-col lg="5" offset-lg="1">
            * {{ item }}
          </b-col>
        </b-row>
      </template>
      <b-row v-else>
        <b-col lg="5">No existen roles con este permiso</b-col>
      </b-row>
      <b-row class="mb-3 mt-1">
        <b-col xl="9">
          Usuarios excepciones con este permiso:
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="7" offset-lg="1">
          * Próximamente :D
        </b-col>
      </b-row>
      <!-- <template v-if="usersWithPermission.length > 0">
        <b-row :id="index" v-for="(item,index) in usersWithPermission" v-bind:key="item.id">
          <b-col lg="7" offset-lg="1">
            * {{ item }}
          </b-col>
        </b-row>
      </template> -->
      <b-row>
        <b-col lg="7" offset-lg="6">
          <b-button @click="$bvModal.hide('permission-modal')" variant="secondary" size="sm" class="mb-3 mt-4">Cerrar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="permission-add-modal" ref="modal" size="lg" :title="'Asignar permiso: ' + permissionSelected.name" hide-footer @hidden="onHidden2">
      <b-row class="mb-4">
        <b-col>
          <a-tabs defaultActiveKey="1" class="kit-tabs" @change="changeTab2">
            <a-tab-pane tab="Rol" key="1" />
            <!-- <a-tab-pane tab="Usuario" key="2"/> -->
          </a-tabs>
        </b-col>
      </b-row>
      <template v-if="tabActive2 == 1">
        <b-row>
          <template v-for="(item,index) in roles">
            <template v-if="true">
              <b-col :key="item.id" :id="index" sm="4" lg="3">{{ item.text }}</b-col>
              <b-col :key="item.id" :id="index" sm="1" lg="1"><b-form-checkbox v-model="item.state" name="check-button" switch /></b-col>
            </template>
          </template>
        </b-row>
        <b-row class="mt-3 mx-auto" align-h="center">
          <b-col xl="2">
            <button class="btn btn-primary" @click="saveForRoles()"> Guardar </button>
          </b-col>
        </b-row>
      </template>
      <!-- <template v-if="tabActive2 == 2">
        <b-row>
          <b-table striped hover :fields="columns" :items="users" head-variant="light" responsive>
            <template #cell(actions)="user">
              <div>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>Seleccionar</span>
                  </template>
                  <button type="button" @click="() => selectSU(user.item.id)" class="btn btn-light mr-2">
                    <i :class="checkPermission(user.item)" />
                  </button>
                </a-tooltip>
              </div>
            </template>
          </b-table>
        </b-row>
      </template> -->
    </b-modal>
    <b-modal id="edit-permission" ref="modal" :title="form.id !== null ? 'Editar permiso' : 'Crear permiso'" hide-footer @hidden="onHidden">
      <b-form ref="todoform">
        <b-form-group id="input-group-2" label="Nombre:" label-for="input-2">
          <b-form-input id="input-2" v-model="form.name" placeholder="Ingrese el nombre"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" label="Descripción:" label-for="input-1">
          <b-form-input id="input-1" v-model="form.description" placeholder="Ingrese la descripción"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3" label="Módulo:" label-for="input-3">
          <b-form-select
            id="input-3"
            v-model="form.idModule"
            :options="modules"
            required
          ></b-form-select>
        </b-form-group>
        <b-button @click="$bvModal.hide('edit-permission')" variant="secondary" size="sm" class="mb-3 mt-3">Cancelar</b-button>
        <b-button @click="savePermission()" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
// import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2.js'
import { mapState } from 'vuex'
import axios from 'axios'
import store from 'store'
import emptyTable from '@/components/custom/cardEmptyList'
import Swal from 'sweetalert2'
// import moment from 'moment'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'permissions',
  components: { emptyTable },
  data() {
    return {
      tabActive2: 1,
      isDisabled: true,
      searchBar: {
        idModule: '',
        name: '',
      },
      form: {
        id: null,
        name: '',
        description: '',
        idModule: 1,
      },
      permissions: [],
      columns: [
        { key: 'id', label: 'Código' },
        { key: 'name', label: 'Nombre' },
        { key: 'description', label: 'Descripción' },
        { key: 'idModule', label: 'Módulo' },
        { key: 'actions', label: 'Acciones', thClass: 'text-center', tdClass: 'text-center' },
      ],
      modules: [],
      roles: [],
      usersWith: [
        14, 15,
      ],
      permissionSelected: {
        name: '',
        actualRoles: [],
      },
      pagination: {
        rows: 5,
        perPage: 10,
        currentPage: 1,
      },
      typingTimer: '',
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    function getRoles() {
      return apiClient2.get('/roles')
    }
    function getPermissions() {
      return apiClient2.get('/permissions')
    }
    function getModules() {
      return apiClient2.get('/modules')
    }
    axios.all([getRoles(), getPermissions(), getModules()])
      .then(axios.spread(function (roles, permissions, modules) {
        next((vm) => {
          vm.setDataRoles(null, roles.data.data)
          vm.setDataPermissions(null, permissions.data.data)
          vm.setDataModules(null, modules.data.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataRoles(err, [])
          vm.setDataPermissions(err, [])
          vm.setDataModules(err, [])
        })
      })
  },
  watch: {
    'searchBar.name': function () {
      this.getByFields()
    },
    'searchBar.idModule': function () {
      this.getByFields()
    },
  },
  methods: {
    setDataRoles (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const roles = []
        console.log(data)
        data.forEach(i => roles.push({ value: i.id, text: i.name, state: false }))
        this.roles = roles
      }
    },
    setDataPermissions (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.permissions = data
        this.pagination.rows = this.permissions.length
      }
    },
    setDataModules (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        const modules = []
        modules.push({ value: '', text: 'Seleccione un Modulo' })
        data.data.forEach(i => modules.push({ value: i.id, text: i.name }))
        this.modules = modules
      }
    },
    moduleName(idModule) {
      for (const module of this.modules) {
        if (module.value === idModule) {
          return module.text
        }
      }
      return false
    },
    linkToPermission(permission, type) {
      this.permissionSelected = { ...permission, actualRoles: [] }
      if (type === 0) {
        apiClient2.get(`permissions/${permission.id}/roles`).then(response => {
          const { data } = response.data
          if (data.length > 0) {
            this.permissionSelected.actualRoles = data.map((rol) => rol.name)
          }
        }).catch(e => {
          console.log(e)
        })
        this.$bvModal.show('permission-modal')
      } else {
        apiClient2.get(`permissions/${permission.id}/roles`).then(response => {
          const { data } = response.data
          if (data.length > 0) {
            this.permissionSelected.actualRoles = data.map((rol) => rol.id)
            for (let i = 0; i < this.roles.length; i++) {
              if (this.permissionSelected.actualRoles.includes(this.roles[i].value)) {
                this.roles[i].state = true
              }
            }
          }
        }).catch(e => {
          console.log(e)
        })
        this.$bvModal.show('permission-add-modal')
      }
    },
    savePermission () {
      if (this.form.id !== null) {
        apiClient2.patch(`permissions/${this.form.id}`, this.form).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
          this.reloadPermissions()
          this.$bvModal.hide('edit-permission')
        }).catch(e => {
          console.log(e)
        })
      } else {
        apiClient2.post('permissions', this.form).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
          this.reloadPermissions()
          this.$bvModal.hide('edit-permission')
        }).catch(e => {
          console.log(e)
        })
      }
    },
    saveForRoles() {
      const hadRoles = (this.permissionSelected.actualRoles.length > 0)
      const inputRoles = this.roles.filter(role => role.state === true).map((role) => role.value)
      // Roles eliminados
      if (hadRoles) {
        const deletedRoles = this.permissionSelected.actualRoles.filter(role => !inputRoles.includes(role))
        if (deletedRoles.length > 0) {
          apiClient2.patch(`permissions/${this.permissionSelected.id}/roles`, { roles: deletedRoles }).then(response => {
            Toast.fire({
              icon: 'success',
              title: response.data.message,
            })
          }).catch(e => {
            console.log(e)
          })
        }
      }
      // Roles nuevos
      const newRoles = inputRoles.filter(role => !this.permissionSelected.actualRoles.includes(role))
      if (newRoles.length > 0) {
        apiClient2.post(`permissions/${this.permissionSelected.id}/roles`, { roles: newRoles }).then(response => {
          Toast.fire({
            icon: 'success',
            title: response.data.message,
          })
        }).catch(e => {
          console.log(e)
        })
      }
      this.$bvModal.hide('permission-add-modal')
    },
    reloadPermissions() {
      apiClient2.get('/permissions').then(response => {
        this.setDataPermissions(null, response.data)
      })
    },
    deletePermission(permission) {
      Swal.fire({
        title: 'Confirmar eliminación',
        text: '¿Esta seguro de que desea eliminar el permiso ' + permission.name + '? \n Se eliminará de todos los usuarios que usen este permiso',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminar',
        cancelButtonText: 'No',
      }).then(async (result) => {
        if (result.isConfirmed) {
          apiClient2.delete(`permissions/${permission.id}`).then(response => {
            Toast.fire({
              icon: 'success',
              title: response.data.message,
            })
            this.reloadPermissions()
          }).catch(e => {
            console.log(e)
          })
        }
      })
    },
    givePermission() {
      this.isDisabled = false
      this.changeTab('2')
      this.$bvModal.hide('permission-modal')
    },
    onHidden (e) {
      this.form = {
        id: null,
        name: '',
        description: '',
        idModule: 1,
      }
    },
    onHidden2 (e) {
      this.roles.forEach(role => {
        role.state = false
      })
    },
    openModal(permission) {
      if (permission) {
        this.form = { ...permission }
      } else {
        this.onHidden()
      }
      this.$bvModal.show('edit-permission')
    },
    onTabChange(key, type) {
      console.log(key, type)
      this[type] = key
    },
    changeTab2(key) {
      console.log(key)
      this.tabActive2 = key
    },
    getByFields() {
      clearTimeout(this.typingTimer)
      this.typingTimer = setTimeout(() => { this.search() }, 500)
    },
    async search() {
      await apiClient2.get('/permissions', { params: { sentParams: this.searchBar } }).then(response => {
        this.setDataPermissions(null, response.data)
      })
    },
  },
  created() {
    this.accessToken = store.get('accessToken')
  },
}
</script>
<style>
  .btnplus {
    position: absolute;
    right:5em;
    z-index:10;
    border-radius: 50%;
  }
</style>
